import { CommonToast } from "../components/common/Toast";
import { COMPANY_URL } from "../constants/apiUrls";

export const uploadFileToS3 = async (
  pathName,
  file,
  token,
  id,
  category,
  paramToken = "",
  isPublic = false,
) => {
  // Allowed MIME types
  const allowedMimeTypes = [
    "application/pdf",
    "text/csv",
    "application/vnd.ms-excel", // some browsers use this for CSV
  ];

  // Allow all image types. Some OS/browser combos (notably Windows +
  // Chrome) report an empty file.type for .heic/.heif, so fall back to
  // the filename extension rather than blocking the upload client-side —
  // the server still validates the actual file content.
  const allowedExtensions = [".heic", ".heif"];
  const hasAllowedExtension = allowedExtensions.some((ext) =>
    file?.name?.toLowerCase().endsWith(ext)
  );
  const isImage = file?.type?.startsWith("image/");
  const isAllowedFileType =
    isImage || allowedMimeTypes.includes(file?.type) || hasAllowedExtension;

  if (!isAllowedFileType) {
    CommonToast.error(
      "Only image files, PDF files, and CSV files are allowed."
    );
    return {
      success: false,
      message: "Invalid file type",
    };
  }

  const apiUrl = `/api/company/upload/`;
  const formData = new FormData();

  formData.append("file", file);

  if (id) {
    formData.append("companyID", id);
    formData.append("pathName", `${pathName}/${id}/`);
  } else {
    formData.append("pathName", `${pathName}/`);
  }

  if (paramToken) {
    formData.append("token", paramToken);
  }

  if(category){
    formData.append("category", category);
  }

  if (isPublic) {
    formData.append("isPublic", isPublic);
  }

  try {
    const headers = token
      ? { Authorization: `Bearer ${token}` }
      : {};

    const response = await fetch(apiUrl, {
      method: "POST",
      headers,
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();

      if (errorData) {
        CommonToast.error(
          errorData?.message || "Image Upload Failure"
        );
        return errorData;
      }
    }

    const responseData = await response.json();

    CommonToast.success(responseData.message);

    return responseData;
  } catch (err) {
    CommonToast.error(
      err?.message || "File upload failed"
    );
    return err;
  }
};